import Header from '../../components/Header';
import { withApollo } from 'react-apollo';
import { getUserData } from '../../utils/graphQLFunctions';

// Create graphql HOC.
let HeaderWithData = withApollo(getUserData()(Header));

export default HeaderWithData;



// WEBPACK FOOTER //
// ./src/containers/HeaderWithData/index.js